/**
 * Product data of the popup's steps 1-3 (Nytt steg 1), printed by php/shop.php as
 * <script id="mscp-popup-spec">. Keyed by "paper|presentation" (the pair a shop card links to).
 */

let cache = null;

function load() {
    if (cache) return cache;
    cache = { products: {}, shopUrl: '/shop/' };
    try {
        const el = document.getElementById('mscp-popup-spec');
        if (el) cache = { ...cache, ...JSON.parse(el.textContent) };
    } catch (e) {
        // no data: the popup keeps its plain look
    }
    return cache;
}

/** The product of a paper/presentation pair, or null when the shop sheet has none for it. */
export function getPopupProduct(paper, presentation = '') {
    const { products } = load();
    const exact = products[`${paper}|${presentation || ''}`];
    if (exact) return exact;
    // The shop link may name another paper than the sheet map (the look's product decides it); the
    // presentation (or the canvas paper) still identifies the card.
    const keys = Object.keys(products);
    const key = (presentation && keys.find((k) => k.split('|')[1] === presentation))
        || keys.find((k) => k === `${paper}|`); // a product without presentation (canvas)
    return key ? products[key] : null;
}

export function getShopUrl() {
    return load().shopUrl;
}

/** Mockup layers of a product with an empty picture window ("DIN BILD HÄR"). */
export function emptyWindowStage(product) {
    const wrap = document.createElement('div');
    wrap.className = 'mscp-pv';
    wrap.innerHTML = product.mockup;
    const win = wrap.querySelector('.mscp-shop__win');
    if (win) {
        win.classList.add('mscp-pv__win--empty');
        win.innerHTML =
            '<span class="mscp-pv__hint"><svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M16 5h6M19 2v6"/><path d="M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5"/><path d="m21 15-3.1-3.1a2 2 0 0 0-2.8 0L6 21"/><circle cx="9" cy="9" r="2"/></svg><span>DIN BILD HÄR</span></span>';
    }
    return wrap;
}
